/* eslint-disable */
// @ts-nocheck
export function initPegasus() {
  var script, init_script, first_script;
  script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://shared.ydstatic.com/js/ke-rlog/1.1.1.js';
  script.defer = true;
  init_script = document.createElement('script');
  init_script.text =
    'var _rlog = _rlog || [];_rlog.push(["_setAccount", 119]);_rlog.push(["_setSecret", "475a647e831a415a8ed553e4eb02553f"]);';
  first_script = document.getElementsByTagName('script')[0];
  first_script.parentNode.insertBefore(script, first_script);
  first_script.parentNode.insertBefore(init_script, first_script);
};
